import { useEffect, useState, useMemo } from "react";
import { PaymentOut, PaymentsService, RequestsService } from "../../../api";

export type PaymentStatus =
  | "PENDING"
  | "COMPLETED"
  | "PARTIAL"
  | "EXCESS";

export const usePaymentStatus = (serviceRequestId: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await PaymentsService.getPaymentSummaryPaymentsSummaryServiceRequestIdGet(
          Number(serviceRequestId)
        );
        setData(res);
      } catch (err) {
        console.error("Error fetching payment summary", err);
      } finally {
        setLoading(false);
      }
    };

    if (serviceRequestId) fetchSummary();
  }, [serviceRequestId]);

  return {
    payments: data?.payments || [],
    status: data?.summary?.status || "PENDING",
    totalPaid: data?.summary?.total_paid || 0,
    totalPayable: data?.summary?.total_payable || 0,
    loading,
  };
};